import { Link } from "react-router-dom";
import React from "react";
import "../styles/ITServices.css";
import itServicesImage from "../assets/services/ITservices 1.jpeg";
import itServicesImage2 from "../assets/services/it services 2.jpeg";

const solutions = [
  {
    title: "Custom Software Development",
    description:
      "Scalable software solutions designed around your business requirements, workflows and long-term goals.",
  },
  {
    title: "Web & Mobile Applications",
    description:
      "Responsive web and mobile applications designed for smooth performance and simple user experiences.",
  },
  {
    title: "UI/UX & Product Design",
    description:
      "Thoughtful digital interfaces that combine visual clarity, usability and a consistent product experience.",
  },
  {
    title: "Cloud Solutions",
    description:
      "Flexible cloud solutions that help businesses improve reliability, accessibility and scalability.",
  },
  {
    title: "API & System Integration",
    description:
      "Connected systems that allow applications and business platforms to exchange information efficiently.",
  },
  {
    title: "IT Consulting & Support",
    description:
      "Practical technology guidance and dependable support to keep your digital operations moving.",
  },
];

const process = [
  {
    title: "Discover",
    description:
      "We understand your business, users, goals and technical requirements before defining the right solution.",
  },
  {
    title: "Plan",
    description:
      "We create a clear roadmap covering technology, design, functionality and implementation.",
  },
  {
    title: "Build",
    description:
      "Our team develops and integrates the solution using suitable technologies and development practices.",
  },
  {
    title: "Improve",
    description:
      "We refine the solution based on feedback, performance and the changing needs of your business.",
  },
];

function ITServices() {
  return (
    <main className="it-page">

      {/* ================= HERO ================= */}
      <section className="it-hero">
        <div className="it-hero-content">
          <span className="it-eyebrow">
            IT SERVICES & SOLUTIONS
          </span>

          <h1>
            Technology that
            <span> Moves Your Business Forward</span>
          </h1>

          <p>
            We create reliable digital solutions that help businesses
            work smarter, connect better and grow with confidence.
          </p>

          <a href="#it-solutions" className="it-primary-btn">
            Explore Solutions
            <span>→</span>
          </a>
        </div>

        <div className="it-hero-visual">
          <div className="it-hero-image">
            <img
              src={itServicesImage}
              alt="IT professionals collaborating"
            />
          </div>
        </div>
      </section>


      {/* ================= WHAT WE DO ================= */}
      <section className="it-intro">

        <div className="it-intro-header">

          <div className="it-intro-label">
            <span>01</span>
            <p>WHAT WE DO</p>
          </div>

          <div className="it-intro-heading">
            <h2>
              Digital solutions built
              <span> around your business</span>
            </h2>

            <p>
              From product development to cloud solutions and system
              integration, we combine technology, design and business
              thinking to create solutions that are practical,
              scalable and easy to use.
            </p>
          </div>

        </div>


        <div className="it-intro-content">

          <div className="it-intro-main-text">
            <span>OUR APPROACH</span>

            <h3>
              Technology should solve problems,
              <strong> not create more of them</strong>
            </h3>

            <p>
              Every digital solution should have a clear purpose.
              We focus on understanding the real requirement first,
              then selecting the right technology to create something
              useful, reliable and ready to grow.
            </p>
          </div>


          <div className="it-intro-points">

            <div className="it-intro-point">
              <span>01</span>

              <div>
                <h4>Business-first thinking</h4>

                <p>
                  We begin with your actual business requirement
                  instead of forcing technology into the process.
                </p>
              </div>
            </div>


            <div className="it-intro-point">
              <span>02</span>

              <div>
                <h4>Simple user experiences</h4>

                <p>
                  We create clear interfaces and practical workflows
                  that people can understand and use easily.
                </p>
              </div>
            </div>


            <div className="it-intro-point">
              <span>03</span>

              <div>
                <h4>Built to grow</h4>

                <p>
                  Our solutions are planned with flexibility so they
                  can evolve as your business grows.
                </p>
              </div>
            </div>

          </div>

        </div>

      </section>


      {/* ================= SERVICES ================= */}
      <section className="it-solutions" id="it-solutions">

        <div className="it-section-heading">

          <div>
            <span className="it-small-label">
              OUR SERVICES
            </span>

            <h2>
              Technology solutions
              <span> for every stage</span>
            </h2>
          </div>

          <p>
          
          </p>

        </div>


        <div className="it-solutions-grid">

          {solutions.map((item) => (
            <article
              className="it-solution-card"
              key={item.title}
            >
              <div className="it-card-content">

                <h3>{item.title}</h3>

                <p>{item.description}</p>

              </div>
            </article>
          ))}

        </div>

      </section>


      {/* ================= TECHNOLOGY ================= */}
      <section className="it-tech-section">

        <div className="it-tech-content">

          <span className="it-small-label">
            SMARTER TECHNOLOGY
          </span>

          <h2>
            Build today,
            <span> Scale tomorrow</span>
          </h2>

          <p>
            Modern businesses need technology that can adapt.
            Our solutions are designed to support your current
            requirements while giving you the flexibility to grow
            in the future.
          </p>


          <div className="it-tech-points">

            <div>
              <strong>01</strong>
              <h4>Modern architecture</h4>
              <p>
                Technology built with performance and flexibility
                in mind.
              </p>
            </div>

            <div>
              <strong>02</strong>
              <h4>Flexible solutions</h4>
              <p>
                Systems that can adapt as your requirements change.
              </p>
            </div>

            <div>
              <strong>03</strong>
              <h4>Long-term support</h4>
              <p>
                Reliable support beyond the initial implementation.
              </p>
            </div>

          </div>

        </div>


        <div className="it-tech-visual">

          <div className="it-tech-image">

            <img
              src={itServicesImage2}
              alt="IT professionals collaborating"
            />

          </div>

        </div>

      </section>


      {/* ================= PROCESS ================= */}
      <section className="it-process">

        <div className="it-process-heading">

          <span className="it-small-label">
            HOW WE WORK
          </span>

          <h2>
            From idea to
            <span> implementation</span>
          </h2>

          <p>
            A simple and structured approach keeps every project
            focused, transparent and aligned with your business goals.
          </p>

        </div>


        <div className="it-process-grid">

          {process.map((item, index) => (
            <article
              className="it-process-item"
              key={item.title}
            >

              <div className="it-process-number">
                {String(index + 1).padStart(2, "0")}
              </div>

              <h3>{item.title}</h3>

              <p>{item.description}</p>

            </article>
          ))}

        </div>

      </section>


      {/* ================= FINAL CTA ================= */}
      <section className="it-final">

        <div className="it-final-content">

          <div className="it-final-main">

            <div className="it-final-label">
              <span></span>
              LET'S CREATE SOMETHING USEFUL
            </div>

            <h2>
              Your next digital
              <span> solution starts here</span>
            </h2>

            <p>
              Tell us what you are trying to build, improve or solve.
              We will help turn your requirement into a practical
              technology solution.
            </p>

          </div>


          <div className="it-final-action">

            <div className="it-final-brand">
              <strong>TECHLYNX INNOVATIONS</strong>

              <p>
                Technology · Design · Development
              </p>
            </div>

            <Link
              to="/contact"
              className="it-final-btn"
            >
              Start a conversation
              <span>↗</span>
            </Link>

          </div>

        </div>

      </section>

    </main>
  );
}

export default ITServices;